import alipayImg from '@/assets/img/payment_alipayhk_md.png';
import wechatpayImg from '@/assets/img/payment_wechatpayhk_md.png';
import cashImg from '@/assets/img/payment_cash_md.png';
import visaImg from '@/assets/img/payment_visa_md.jpg';
import mastercardImg from '@/assets/img/payment_mastercard_md.png';
import fpsImg from '@/assets/img/payment_fps_md.png';

export const paymentInfos = [
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '35',
        img: alipayImg,
        name: 'Alipay HK (PC)'
        // code: 'AlipayHK_PC_MPay'
    },
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '36',
        img: alipayImg,
        name: 'Alipay HK (Mobile)'
        // code: 'AlipayHK_Mobile_MPay'
    },
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '41',
        img: wechatpayImg,
        name: 'Wechat Pay HK'
        //code: 'WechatPayHK_MPay'
    },
    {
        pymtSrvcPrvdId: 'CASH',
        pymtMthdId: 'CASH',
        img: cashImg,
        name: 'Cash'
        //code: 'Cash'
    },
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '37V',
        img: visaImg,
        name: 'Visa (PC)'
        //code: 'MpgsVisa_PC_MPay'
    },
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '37M',
        img: mastercardImg,
        name: 'Mastercard (PC)'
        //code: 'MpgsMastercard_PC_MPay'
    },
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '38V',
        img: visaImg,
        name: 'Visa (Mobile)'
        //code: 'MpgsVisa_Mobile_MPay'
    },
    {
        pymtSrvcPrvdId: 'MPAY',
        pymtMthdId: '38M',
        img: mastercardImg,
        name: 'Mastercard (Mobile)'
        //code: 'MpgsMastercard_Mobile_MPay'
    },
    {
        pymtSrvcPrvdId: 'HSBC',
        pymtMthdId: 'FPS',
        img: fpsImg,
        name: 'FPS'
        //code: 'Fps_Hsbc'
    }
];
